"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var global = window || global;
    global.assets = '/app/themes/tedee/assets/images/';
    global.IsInViewport = function (el) {
        if (typeof jQuery === "function" && el instanceof jQuery)
            el = el[0];
        var rect = el.getBoundingClientRect();
        return (rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth));
    };
};
exports.init = init;
